// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import React from 'react';
import { Form } from 'react-final-form';
import styles from './CreateUpdateTemporaryStorageInputForm.module.scss';
import { InputDataListField, Suggestion } from '../InputDataListField';
import { validateMaxLength } from 'util/validator';
import { useTranslation } from 'react-i18next';
import { TemporaryStorage } from 'components/organisms/TemporaryStorageManagement';
import { createAxios } from 'ts/createAxios';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import { handleError } from 'util/errorHandler';
import { API_ENDPOINTS } from 'util/endPoints';
import { getApiPath } from 'util/commons';

export enum CreateUpdateTemporaryStorageFormInputType {
  add,
  update,
}

interface Props {
  type: CreateUpdateTemporaryStorageFormInputType;
  onSubmit: () => void;
  detailTemporaryStorage?: TemporaryStorage;
  dataSuggestions: Suggestion[];
  colorIndex: number;
}

type TemporaryStorageInput = {
  name: string;
};

const CreateUpdateTemporaryStorageInputForm: React.FC<Props> = ({
  type,
  onSubmit,
  detailTemporaryStorage,
  colorIndex,
}) => {
  const { t } = useTranslation();
  const api = createAxios();
  const { siteId } = useParams<{ operatorId: string; siteId: string }>();
  const callAPICreateTemporaryStorage = async (e: TemporaryStorageInput) => {
    try {
      await api.post(API_ENDPOINTS.TEMPORARY_STORAGES, {
        name: e.name.trim(),
        color: String(colorIndex),
        siteId: siteId,
      });
      onSubmit();
      toast.success(t('messages.M_010'));
    } catch (error) {
      handleError(error);
    }
  };

  const callAPIUpdateTemporaryStorage = async (
    e: TemporaryStorageInput,
    id: number
  ) => {
    try {
      await api.put(
        getApiPath(API_ENDPOINTS.TEMPORARY_STORAGE_DETAIL, { id }),
        {
          name: e.name.trim(),
          sideId: siteId,
        }
      );
      onSubmit();
      toast.success(t('messages.M_011'));
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className={styles.createBody}>
      <Form<TemporaryStorageInput>
        initialValues={{ name: detailTemporaryStorage?.name }}
        onSubmit={(e) => {
          if (type === CreateUpdateTemporaryStorageFormInputType.add) {
            callAPICreateTemporaryStorage(e);
          } else {
            callAPIUpdateTemporaryStorage(
              e,
              Number(detailTemporaryStorage?.id)
            );
          }
        }}
        validate={(values) => {
          return {
            name:
              !values.name || values.name.trim().length === 0
                ? t('temporary_storage_management.validator_message')
                : undefined,
          };
        }}
      >
        {(props) => (
          <form onSubmit={props.handleSubmit} className={styles.formInput}>
            <div className={styles.inputFrame}>
              <InputDataListField
                validate={(value) =>
                  validateMaxLength(
                    value,
                    100,
                    t('temporary_storage_management.thead_name')
                  )
                }
                label={t('temporary_storage_management.thead_name')}
                placeholder={t('temporary_storage_management.thead_name')}
                name="name"
                required
                maxlength={100}
              />
            </div>

            <div className={styles.line} />

            <div className={styles.submit}>
              <button
                disabled={props.invalid}
                className={
                  props.invalid ? styles.disableButton : styles.submitButton
                }
                type="submit"
              >
                {type === CreateUpdateTemporaryStorageFormInputType.add
                  ? t('modal_temporary_storage.button_add')
                  : t('common.modal_update.edit_button')}
              </button>
            </div>
          </form>
        )}
      </Form>
    </div>
  );
};

export default CreateUpdateTemporaryStorageInputForm;
